var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_4393",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 4393",
    transform: "translate(-16308 666)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_18095",
    "data-name": "\\u9577\\u65B9\\u5F62 18095",
    width: 20,
    height: 20,
    transform: "translate(16308 -666)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_379",
    "data-name": "\\u30D1\\u30B9 379",
    d: "M91.515,6.46V4.611a1.487,1.487,0,0,0-1.486-1.486H85.914a1.487,1.487,0,0,0-1.486,1.486V6.46H81.094V18.548H91.723V17.3H82.345V7.71h2.084V8.752h1.25V7.71h4.585V8.752h1.25V7.71H93.6V18.756h1.25V6.46Zm-5.836,0V4.611a.235.235,0,0,1,.235-.235h4.115a.235.235,0,0,1,.235.235V6.46Z",
    transform: "translate(16230.276 -667.187)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.2d36710f7276794972eab482b18dc2d0.svg";
export { ForwardRef as ReactComponent };